import React from 'react';
import { useTheme } from '@mui/material/styles';

interface NeuraStrikeLogoProps {
  className?: string;
  height?: number;
}

const NeuraStrikeLogo: React.FC<NeuraStrikeLogoProps> = ({ className = '', height = 28 }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  // Colors based on theme
  const neuraColor = isDarkMode ? '#06b6d4' : '#6366f1'; // Cyan in dark, Indigo in light
  const strikeColor = isDarkMode ? '#ffffff' : '#1e293b'; // White in dark, Dark slate in light

  return (
    <a href="/" className={`flex items-center justify-center group ${className}`}>
      <svg
        viewBox="0 0 200 28"
        className="transition-all duration-300 group-hover:opacity-80"
        fill="none"
        style={{ height: `${height}px` }}
      >
        <text
          x="0"
          y="22"
          style={{
            fontFamily: 'system-ui, -apple-system, sans-serif',
            fontSize: '22px',
            fontWeight: 600,
            letterSpacing: '0.05em',
            fill: neuraColor
          }}
        >
          NEUR
        </text>
        <path
          d="M58 22L64 6L70 22M60 16H68"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          style={{ stroke: neuraColor }}
        />
        <text
          x="74"
          y="22"
          style={{
            fontFamily: 'system-ui, -apple-system, sans-serif',
            fontSize: '22px',
            fontWeight: 600,
            letterSpacing: '0.05em',
            fill: strikeColor
          }}
        >
          STRIKE
        </text>
      </svg>
    </a>
  );
};

export default NeuraStrikeLogo;
